<template>
  <div class="invoice-component">
    <div class="invoice-choice">
      <RadioGroup v-model="value.type">
        <Radio :label="0">
          <span class="choice-value">{{ $t('invoice.personal_invoice') }}</span>
        </Radio>
        <Radio :label="1">
          <span class="choice-value">{{ $t('invoice.company_invoice') }}</span>
        </Radio>
      </RadioGroup>
    </div>
    <div class="personal-invoice-tip" v-if="value.type === 0">
      <div v-html="$t('invoice.personal_tip')"></div>
      <div class="invoice-tip">
        <p>{{ $t('invoice.invoice_tip') }}</p>
      </div>
    </div>
    <div class="company-invoice-info" v-else>
      <div v-for="item in datas" :key="item.id" @click.stop="onChoiceInvoice(item)" class="invoice-btn" :class="{'invoice-btn-selected':value.id===item.id}">
        {{item.invoice_head}}<span style="color: #428dfb" v-if="value.id===item.id"> ({{item.tax_id}})</span>
        <b></b>
      </div>
      <div @click.stop="onAddInvoice" class="invoice-btn" :class="{'invoice-btn-selected':value.id===0}">
        <span style="color: #428dfb">{{ $t('invoice.add_invoice') }}</span>
        <b></b>
      </div>
      <div class="company-invoice-form" v-if="value.id === 0">
        <div>
          <p>{{ $t('invoice.tax_id') }}</p>
          <Input v-model="value.tax_id" :maxlength="8" :placeholder="$t('invoice.tax_id_tip')" @on-change="onTaxIdChange"/>
          <p v-if="hasError" style="color:#ff0606">{{$t('invoice.tax_id_tip2')}}</p>
        </div>

        <div>
          <p>{{ $t('invoice.invoice_head') }}</p>
          <Input v-model="value.invoice_head" :placeholder="$t('invoice.invoice_head_tip')"/>
        </div>
      </div>
      <div class="invoice-tip">
        <p>{{ $t('invoice.invoice_tip2') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
    import { httpGet } from '@/api/http';

    export default {
        name: 'MyInvoice',
        props: {
            value: Object
        },
        data () {
            return {
                datas: [],
                hasError: false
            }
        },
        methods: {
            getData: function () {
                httpGet('/v1/invoices').then(res => {
                    this.datas = res;
                })
            },
            onChoiceInvoice: function (item) {
                this.value.id = item.id
                this.value.tax_id = item.tax_id
                this.value.invoice_head = item.invoice_head
            },
            onAddInvoice: function () {
                this.value.id = 0
            },
            onTaxIdChange: function () {
                if (this.value.tax_id.length !== 8 || !(/^\d{8}$/.test(this.value.tax_id))) {
                    this.hasError = true
                } else {
                    this.hasError = false
                }
            }
        },
        created () {
            this.getData()
        }
    }
</script>

<style lang="scss">
.invoice-component{
  background: #f3f3f3;
  width: 100%;
  max-width: 880px;
  padding: 2px;
  .invoice-choice{
    display: flex;
    .choice-value{
      display: inline-block;
      font-size: 1.1rem;
      line-height: 130%;
    }
  }
  .personal-invoice-tip{
    padding: 10px;
    color:#ff0606;
  }

  .company-invoice-info{
    padding: 10px;
    display: flex;
    flex-direction: column;
    width: 100%;
    //max-width: 350px;

    .invoice-btn{
      background: #ffffff;
      display: inline-block;
      position: relative;
      z-index: 1;
      line-height: 18px;
      margin: 2px 10px 4px 0;
      border: 1px solid #ebebeb;
      padding: 6px 18px;
      text-align: left;
      vertical-align: middle;
      cursor: pointer;
      max-width: 350px;
    }
    .invoice-btn-selected{
      border: 2px solid #e4393c;
      padding: 6px 18px;
      z-index: 10;

      b{
        display: block;
        position: absolute;
        right: 0;
        bottom: 0;
        width: 12px;
        height: 12px;
        overflow: hidden;
        background: url('~@/assets/selected-icon.png') no-repeat
      }
    }

    .company-invoice-form{
      display: flex;
      &>div{
        margin-right: 10px;
      }
    }
  }
  .invoice-tip{
    padding: 10px 0;
    font-weight: bold;
    color:#ff0606;
  }
}
@media screen and (max-width:768px ) {
  .invoice-component{
    .company-invoice-info{
      .company-invoice-form{
        flex-direction: column;
      }
    }
  }
}
</style>
